import { createServer, Response, Model } from "miragejs";
import sample from "lodash/sample";
import range from "lodash/range";
import random from "lodash/random";
import find from "lodash/find";
import moment from "moment";
import get from "lodash/get";
import { nanoid } from "nanoid";
import { PATIENT_URL, PRACTITIONER_URL } from "../api";
import patients from "./fixtures/patients.json";
import practitioners from "./fixtures/practitioners.json";
import t from "../translate";
import { components } from "./fixtures/components";
import { units } from "./fixtures/units";
import { getRandomObservation } from "./fixtures/observations";

function findByRut(rut) {
  return ({ resource: { identifier } }) =>
    get(
      find(identifier, {
        system: "https://www.registrocivil.cl/RUN",
      }),
      "value"
    ) === rut;
}

export default function createMockServer() {
  createServer({
    routes() {
      this.get(
        PATIENT_URL,
        () => {
          const patient = sample(patients.entry);
          return { ...patients, entry: [patient] };
        },
        { timing: 200 }
      );

      this.get(
        PRACTITIONER_URL,
        (schema, request) => {
          const rut = request.queryParams.getPractitionerByIdentificationNumber;
          const practitioner = practitioners.entry.find(findByRut(rut));

          if (!practitioner) return { ...practitioners, entry: [] };

          practitioner.resource.qualification = [
            {
              code: { text: sample(["Médico", "Enfermera"]) },
              issuer: { display: sample(["UCH", "PUC", "PUCV", "UDEC"]) },
            },
          ];

          return { ...practitioners, entry: [practitioner] };
        },
        { timing: 200 }
      );

      this.get(
        "https://servers.techconnect.cl/HAPI/Specimen",
        () => {
          const specimen = {
            id: nanoid(),
            resourceType: "Specimen",
            type: {
              coding: [
                {
                  system: "http://snomed.info/sct",
                  code: "BLDV",
                  display: "Blood venous",
                },
              ],
            },
            subject: {
              reference: "Patient/6f7acde5-db81-4361-82cf-886893a3280c",
            },
            receivedTime: moment()
              .subtract(sample(range(10)), "days")
              .subtract(sample(range(10)), "hours")
              .format(),
          };

          return { entry: [{ resource: specimen }] };
        },
        { timing: 200 }
      );

      this.get(
        `https://servers.techconnect.cl/ST/Questionnaire/:id`,
        (schema, request) => {
          return {
            code: [{ code: request.params.id }],
            item: components[request.params.id].map((code) => ({
              code: [{ code }],
              name: t(code),
            })),
          };
        }
      );

      this.get(
        "https://servers.techconnect.cl/ST/CodeSystem/$lookup",
        (schema, request) => {
          if (request.queryParams.system === "http://cens.cl/lab-ref-ranges") {
            const values = units[request.queryParams.code];
            if (!values) return {};

            return {
              parameter: [
                {
                  part: [
                    {
                      valueCode: "unit",
                    },
                    {
                      valueCoding: {
                        code: values.unit,
                      },
                    },
                  ],
                },
                {
                  part: [
                    {
                      valueCode: "min-range",
                    },
                    {
                      valueInteger: values.range[0],
                    },
                  ],
                },
                {
                  part: [
                    {
                      valueCode: "max-range",
                    },
                    {
                      valueInteger: values.range[1],
                    },
                  ],
                },
              ],
            };
          }
        }
      );

      this.get(`https://servers.techconnect.cl/HAPI/Observation`, () => {
        return {
          entry: range(random(0, 4)).map(() => ({
            resource: getRandomObservation(),
          })),
        };
      });

      this.get("https://servers.techconnect.cl/HAPI/Observation/:id", () => {
        return {
          resource: getRandomObservation(),
        };
      });
    },
  });
}
